/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type SubscriptionUsageQueryVariables = {
    subscriptionID: string;
    before: string;
    after: string;
};
export type SubscriptionUsageQueryResponse = {
    readonly subscription: {
        readonly usage?: {
            readonly intervals: ReadonlyArray<{
                readonly totalCosts: ReadonlyArray<{
                    readonly value: number;
                    readonly currency: string;
                }>;
                readonly startDate: string;
                readonly groupedCharges: ReadonlyArray<{
                    readonly charge: {
                        readonly id: string;
                        readonly name: string;
                        readonly description: string;
                    } | null;
                    readonly unitsUsed: number;
                    readonly totalCost: number;
                }>;
            }>;
        } | null;
    } | null;
};
export type SubscriptionUsageQuery = {
    readonly response: SubscriptionUsageQueryResponse;
    readonly variables: SubscriptionUsageQueryVariables;
};



/*
query SubscriptionUsageQuery(
  $subscriptionID: ID!
  $before: Time!
  $after: Time!
) {
  subscription: node(id: $subscriptionID) {
    __typename
    ... on Subscription {
      usage(before: $before, after: $after, intervalSeconds: 86400) {
        intervals {
          totalCosts {
            value
            currency
          }
          startDate
          groupedCharges {
            charge {
              id
              name
              description
            }
            unitsUsed
            totalCost
          }
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "subscriptionID"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "subscriptionID"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Variable",
          "name": "before",
          "variableName": "before"
        },
        {
          "kind": "Literal",
          "name": "intervalSeconds",
          "value": 86400
        }
      ],
      "concreteType": "SubscriptionUsage",
      "kind": "LinkedField",
      "name": "usage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UsageInterval",
          "kind": "LinkedField",
          "name": "intervals",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Amount",
              "kind": "LinkedField",
              "name": "totalCosts",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currency",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ChargeGroupedUsage",
              "kind": "LinkedField",
              "name": "groupedCharges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Charge",
                  "kind": "LinkedField",
                  "name": "charge",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "unitsUsed",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalCost",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Subscription",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionUsageQuery",
    "selections": [
      {
        "alias": "subscription",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SubscriptionUsageQuery",
    "selections": [
      {
        "alias": "subscription",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "17037db2db6e69b8cf12a78cc5402e76",
    "id": null,
    "metadata": {},
    "name": "SubscriptionUsageQuery",
    "operationKind": "query",
    "text": "query SubscriptionUsageQuery(\n  $subscriptionID: ID!\n  $before: Time!\n  $after: Time!\n) {\n  subscription: node(id: $subscriptionID) {\n    __typename\n    ... on Subscription {\n      usage(before: $before, after: $after, intervalSeconds: 86400) {\n        intervals {\n          totalCosts {\n            value\n            currency\n          }\n          startDate\n          groupedCharges {\n            charge {\n              id\n              name\n              description\n            }\n            unitsUsed\n            totalCost\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e5ae06ccf82e6fb5f178a44c224799eb';
export default node;
